const bitManipulationProblems = [
  {
      title: "Single Number",
      url: "https://leetcode.com/problems/single-number/"
    },
    {
      title: "Number of 1 Bits",
      url: "https://leetcode.com/problems/number-of-1-bits/"
    },
    {
      title: "Power of Two",
      url: "https://leetcode.com/problems/power-of-two/"
    },
    {
      title: "Reverse Bits",
      url: "https://leetcode.com/problems/reverse-bits/"
    }
];
export default bitManipulationProblems;